module.exports = __webpack_public_path__ + "img/no-cache-Computer-Mockup.2838b1f7.jpg";